/** Splits `text` into alternating plain and matching parts. */
export function splitMatches(text: string, query: string): { text: string; match: boolean }[] {
  const term = query.trim().toLowerCase();
  if (!term) return [{ text, match: false }];

  const lower = text.toLowerCase();
  const parts: { text: string; match: boolean }[] = [];
  let start = 0;
  let index = lower.indexOf(term);
  while (index !== -1) {
    if (index > start) parts.push({ text: text.slice(start, index), match: false });
    parts.push({ text: text.slice(index, index + term.length), match: true });
    start = index + term.length;
    index = lower.indexOf(term, start);
  }
  if (start < text.length) parts.push({ text: text.slice(start), match: false });
  return parts;
}
